export function isDeCenterAccredited (accredComps, examFlags) {
  let isSameLevel = true
  const accredLevel = accredComps.level_applicability_code || 'none'

  if (Array.isArray(examFlags)) {
    isSameLevel = accredLevel === 'none' || examFlags.includes(accredLevel)
  }

  return Date.now() < new Date(accredComps.expires_at) && accredComps.workers > 0 &&
    !accredComps.suspended && isSameLevel
}
